
<div class="t-content" id="flights" [ngStyle]="{'margin-bottom': componentResults ? '70px' : '35px'}">

    <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center" style="gap: 1em;">
        <img src="../../../../../assets/img/app/categories-search-box/AEREO.svg" style="width: 24px" alt="">
        <h3 class="mb-0 ml-2" style="font-family: 'Rubik', serif">Editar búsqueda de vuelos</h3>
    </div>
    <div>
        <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
          <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important;">&times;</span>
        </button>
    </div>
  </div>

  <div *ngIf="componentResults && loadingData"
       class="loading-container d-flex flex-column align-items-center justify-content-center py-5 mt-3">


    <div class="logo-loading mb-4">
      <img [src]="agencyImagen"
           alt="Logo"
           class="loading-logo animate__animated animate__pulse animate__infinite">
    </div>


    <div class="text-center animate__animated animate__fadeIn">
      <h4 class="text-muted mb-3">Cargando información, gracias por esperar...</h4>


      <div [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}" class="spinner-border" role="status">
      </div>
    </div>
  </div>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="d-flex mb-3 mt-3" style="gap: .5em;">
      <select name="" id=""
              class="px-2"
              style="border-radius: 6px;height: 32px;font-family: 'Rubik', sans-serif !important;font-size: 12px !important;font-weight: 400 !important;"
              [ngStyle]="{
                          'background-color':  getClientsSettingAppBooking?.clients_setting_global?.color_main_1 +'22',
                          'border': '1px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1,
                          'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                         }"
              (change)="changeWay($event.target.value)"
                         >
        <ng-container *ngFor="let way of wayArr">
          <option
                  class="px-2"
                  style="font-family: 'Rubik', sans-serif !important;font-size: 12px !important;font-weight: 400 !important;"
                  [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  value="{{way.value}}">{{way.label}}</option>
        </ng-container>
      </select>
    </div>
    <div class="d-flex mb-3 mt-3" style="gap: .5em;">
      <div class="d-flex align-items-center w-100 position-relative justify-content-between"  id="form-destination" >

            <input type="text"
                    name="destino"
                    matInput
                    maxlength="50"
                    class="form-control input-search-box"
                    style="background-color: white;"
                    #destination
                    formControlName='origin'
                    placeholder="Origen (Aeropuerto, Ciudad)"
                    [matAutocomplete]="origin"


            >

            <mat-autocomplete #origin="matAutocomplete"
                              [displayWith]="displayFn"
                              (optionSelected)="getLocationsAll($event.option.value, 'origin')">

                 <ng-container *ngIf="destinationOptions | async as options">

                  <!-- AEROPUERTOS -->
                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'airport'">
                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.airports && item.airports.length > 0">
                          <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center" style="gap: 0.25em;">
                              <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px;">
                              <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Aeropuerto</span>
                            </div>
                            <div>
                              <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.airports.length}} resultados</span>
                            </div>
                          </div>
                      </mat-option>
                      <ng-container *ngFor="let airport of item.airports">
                        <mat-option [value]="{data: airport, type: item.type}">
                          <div style="margin-left: 2.4em;">
                            <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 400 !important; line-height: 1;">{{ capitalize(airport.name) }},
                            <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                              {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important;">({{airport.iata}})</span>
                            </span></p>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                                  <!-- UBICACIONES -->
                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'city'">
                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.cities && item.cities.length > 0">
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center" style="gap: 0.25em;">
                            <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px;">
                            <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Ubicación</span>
                          </div>
                          <div>
                            <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.cities.length}} resultados</span>
                          </div>
                        </div>
                      </mat-option>
                      <ng-container *ngFor="let city of item.cities">
                        <mat-option [value]="{data: city, type: item.type}">
                          <div style="margin-left: 2.4em;">
                            <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">{{ capitalize(city.main_text) }},
                            <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">{{ capitalize(city.secondary_text) }}</span>
                            </p>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                 </ng-container>

            </mat-autocomplete>

                     <div class="container-button-transfer-destination">
            <div class="position-relative group-button-transfer-destination">

              <i
                role="button"
                tabindex="0"
                class="bi bi-circle-fill circle-btn"
                [ngStyle]="{
                            'text-shadow': isHovered ? '0px 0px 5px ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : ''
                              }"
                (mouseenter)="isHovered = true"
                (mouseleave)="isHovered = false"
                (click)="swapLocations()"
              ></i>
              <i
                  role="button"
                  tabindex="0"
                  class="bi bi-arrow-left-right swap-btn"
                  (click)="swapLocations()"
                  [ngStyle]="{
                              'color': isHovered ?  getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : ''
                              }"
                  (mouseenter)="isHovered = true"
                  (mouseleave)="isHovered = false"
              ></i>
            </div>
         </div>


            <input type="text"
                    name="destino"
                    matInput
                    maxlength="50"
                    class="form-control input-search-box"
                    style="background-color: white;margin-left:.25em;"
                    #destination
                    formControlName='destination'
                    placeholder="Destino (Aeropuerto, Ciudad)"
                    [matAutocomplete]="destination"

            >

             <mat-autocomplete #destination="matAutocomplete"
                              [displayWith]="displayFn"
                              (optionSelected)="getLocationsAll($event.option.value, 'destination')">


                <ng-container *ngIf="destinationOptions_ | async as options">

                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'airport'">
                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.airports && item.airports.length > 0">
                          <div class="d-flex justify-content-between">
                            <div class="d-flex align-items-center" style="gap: 0.25em;">
                              <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px;">
                              <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Aeropuerto</span>
                            </div>
                            <div>
                              <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.airports.length}} resultados</span>
                            </div>
                          </div>
                      </mat-option>
                      <ng-container *ngFor="let airport of item.airports">
                        <mat-option [value]="{data: airport, type: item.type}">
                          <div style="margin-left: 2.4em;">
                            <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 400 !important; line-height: 1;">{{ capitalize(airport.name) }},
                            <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">
                              {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important;">({{airport.iata}})</span>
                            </span></p>
                          </div>
                        </mat-option>
                      </ng-container>
                    </ng-container>
                  </ng-container>

                  <ng-container *ngFor="let item of options">
                    <ng-container *ngIf="item.type === 'city'">
                      <mat-option disabled style="background-color: #f4f4f4;height: 42px;" *ngIf="item.cities && item.cities.length > 0">
                        <div class="d-flex justify-content-between">
                          <div class="d-flex align-items-center" style="gap: 0.25em;">
                            <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px;">
                            <span class="mt-1" style="font-family: 'Rubik', serif; font-size: 13px !important; font-weight: 600 !important;">Ubicación</span>
                          </div>
                          <div>
                            <span style="font-family: 'Rubik', serif; font-size: 11px !important; font-weight: 400 !important;">{{item.cities.length}} resultados</span>
                          </div>
                        </div>
                      </mat-option>
                      <ng-container *ngFor="let city of item.cities">
                        <mat-option [value]="{data: city, type: item.type}">
                          <div style="margin-left: 2.4em;">
                              <p class="mb-0" style="font-family: 'Rubik'; font-size: 14px !important; font-weight: 600 !important; line-height: 1;">{{ capitalize(city.main_text) }},
                              <span class="mb-0" style="font-family: 'Rubik'; font-size: 12px !important; line-height: 1;font-weight: 400 !important;">{{ capitalize(city.secondary_text) }}</span>
                            </p>
                          </div>
                        </mat-option>
                      </ng-container>
                  </ng-container>
                </ng-container>



                </ng-container>

             </mat-autocomplete>
        </div>

      <div  id="form-destination" style="width:25%">
          <div class="position-relative">
             <input
                  formControlName="arrivalDate"
                  type="text"
                  class="form-control input-search-box"
                  id="departureDate"
                  placeholder="{{selectedNoDateDefined ? 'Sin fecha' : 'Seleccionar fecha'}}"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="now"
                  [bsConfig]="dpConfig"
                  readonly
                  [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1},
                              ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}}"
                />
          </div>
      </div>
      <div  id="form-destination" style="width:25%">
          <div class="position-relative">
                <input
                  formControlName="departureDate"
                  type="text"
                  class="form-control input-search-box"
                  id="departureDate"
                  placeholder="{{selectedNoDateDefined ? 'Sin fecha' : 'Seleccionar fecha'}}"
                  autocomplete="off"
                  bsDatepicker
                  [minDate]="now"
                  [bsConfig]="dpConfig"
                  readonly
                  [ngStyle]="{':host tr.ng-star-inserted td.active.start-date.available::after': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1},
                              ':host tr.ng-star-inserted td.active.end-date.available::before': {'background': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}}"
                />
          </div>
      </div>
      <div  id="form-destination" style="width: 50%">
         <div class="position-relative">
           <button
            #triggerButton
            type="button"
            class="form-control btn-usb-rp d-flex align-items-center justify-content-between element-config-passenger"
            (click)="_openModal();"
            [attr.aria-expanded]="!isCollapsed"
            aria-controls="false"
          >
            <p class="p-0 m-0 align-self-center align-middle font-poppins text-passenger-input"> {{ passengers }}</p>

            <img width="10" height="10" src="../../../../../assets/img/app/little-icons/arrow-down-black.svg" />
          </button>
         </div>
      </div>
      <div id="form-destination" style="width:30%">
           <div *ngIf="userService.itineraryActive">
            <button *ngIf="userService.itineraryActive.length == 0"
                    class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
                    (click)="fileActive()"
                    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                    type="button">
              <span>BUSCAR</span>
            </button>
            <button *ngIf="userService.itineraryActive.length > 0 && validateButtonSearch"
                  class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
                  (click)="filePaid()"
                  [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                  type="button">
            <span>BUSCAR</span>
          </button>
            <button *ngIf="userService.itineraryActive.length > 0 && !validateButtonSearch"
                    class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
                    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                    [disabled]="!_form.valid"
                    type="submit">
              <span>BUSCAR</span>
            </button>
         </div>
      </div>
    </div>

    <div class="d-flex mb-3 mt-3" style="gap: .25em;">
      <div class="d-flex align-items-center w-100 position-relative justify-content-center" style="gap: .5em;" id="form-destination">
        <input
          type="checkbox"
          (change)="noDateDefined($event)"
          [checked]="selectedNoDateDefined">
        <p class="mb-0" style="font-family: 'Rubik', sans-serif !important;font-size: 12px !important;font-weight: 400 !important;color: black;line-height: 1;">
          Todavía no tengo fecha definida
        </p>
      </div>
    </div>

  </form>



</div>


